import { Injectable } from '@angular/core';
import { InsightsVisualizationProperties, SignalsProperties } from '../../../constants/constants';
import { SignalsPanel, SignalsType, SignalsVizPanel } from '../../../model/types';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
  public getInsightsProperties(): Array<SignalsPanel> {
    return SignalsProperties;
  }

  public getInsightsPropertiesForFilters(): Array<SignalsPanel> {
    return SignalsProperties.filter((property) => property.showAsFilter === true);
  }

  /**
   * Return all possible visualizations (including default selected state and feature flags)
   *
   * @returns Array of Visualization properties that can be used as panels
   */
  public getInsightsPropertiesForVisualizations(): Array<SignalsVizPanel> {
    return InsightsVisualizationProperties;
  }

  public getPropertyDictionary(property: SignalsType) {
    const type = this.getInsightsProperties().find((d) => d.type === property);
    return type ? type.dictionary : null;
  }
}
